import { render, staticRenderFns } from "./Copyright.vue?vue&type=template&id=e8ffc7ca&scoped=true&"
var script = {}
import style0 from "./Copyright.vue?vue&type=style&index=0&id=e8ffc7ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ffc7ca",
  null
  
)

export default component.exports